/**
 * 사이트 기준 통화 코드.
 * 출처: /v1/site SSE → Routers 에서 localStorage('siteCurrency') 에 저장한 site.currency_type.
 * 미설정(첫 SSE 도착 전) 시 'JPY' 폴백.
 *
 * NOTE: 함수 형태로 export — 매 호출 시 평가되어야 SSE 로 갱신된 값을 즉시 반영한다.
 * (const 로 두면 모듈 import 시점 값이 영구히 박힌다.)
 */
export const getBaseCurrency = () => localStorage.getItem('siteCurrency') || 'JPY'

/**
 * 유저 화면 금액 표시 소수점 자릿수 (site.user_decimal_places).
 * 출처: /v1/site SSE → Routers 에서 localStorage('userDecimalPlaces') 에 저장.
 * 미설정 시 0(정수) 폴백. getBaseCurrency 와 동일하게 함수형 — SSE 갱신 즉시 반영.
 */
export const getUserDecimalPlaces = () => {
  const v = parseInt(localStorage.getItem('userDecimalPlaces'), 10)
  return Number.isFinite(v) && v >= 0 ? v : 0
}

/**
 * 금액 포맷 — user_decimal_places 자릿수로 절삭(반올림 ❌) 후 콤마 표시.
 * 소수점은 0이 아닌 마지막 자리까지만 표시(trailing zero 제거).
 *   formatMoney(0.5)      // "0.5"  (user_decimal_places>=1)
 *   formatMoney(1234.567) // "1,234.56" (자릿수 2)
 * @param {number|string} value
 * @param {{ decimalPlaces?: number }} [opts] - 강제 자릿수(미지정 시 사이트 설정)
 */
export const formatMoney = (value, opts = {}) => {
  const dp = opts.decimalPlaces != null ? opts.decimalPlaces : getUserDecimalPlaces()
  const decimals = Math.max(0, Math.floor(Number(dp) || 0))
  const n = Number(value)
  if (!Number.isFinite(n)) return '0'
  const factor = Math.pow(10, decimals)
  const truncated = (n >= 0 ? Math.floor(n * factor) : Math.ceil(n * factor)) / factor
  return truncated.toLocaleString('ja-JP', { minimumFractionDigits: 0, maximumFractionDigits: decimals })
}
